// export const url = "http://192.168.1.32:3008"
// export const url = "http://192.168.1.208:3008"
// export const url = "http://98.130.88.168:3008";
// export const url = "https://webbackend.bill365.app"
export const url = "https://webbackend.synergicpos.in"

